import React from 'react';
import cn from 'classname';
import './index.less';

function Row({ row, markChecked }) {
	const isChecked = row.is_checked_good !== null;

	return (
		<tr className={cn({
			'checked_good_row': row.is_checked_good,
			'checked_bad_row': row.is_checked_good === false
		})}>
			<td>
				<p className="margin-top-5">{row.id}</p>
				<p className="margin-top-5">{row.created_at}</p>
				<p className="margin-top-5">{row.manager}</p>
			</td>
			<td>
				<p className="margin-top-5">{row.affiliate_id}</p>
				<p className="margin-top-5">{row.offer}</p>
				<p className="margin-top-5">{row.country}</p>
			</td>
			<td>
				{ row.campaign_id && <p> CampId: {row.campaign_id}</p> }
				{ row.sid && <p>Sid: {row.sid} {row.sid_type ? `(${row.sid_type})` : ''}</p>}
			</td>
			<td>{row.payout}$</td>
			<td>{row.traffic_source}</td>
			<td>{row.after_review_count}</td>
			<td>{row.checked_at}</td>
			<td className="padding-top-30">
				{
					!isChecked &&
					<div className="display-flex flex-center">
						<span
							className="icon-approved-common margin-0-10"
							onClick={markChecked.bind(null, row.id, true)}
						></span>
						<span
							className="icon-rejected-common margin-0-10"
							onClick={markChecked.bind(null, row.id, false)}
						></span>
					</div>
				}
			</td>
		</tr>
	);
}

export default Row;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/table-risky/row.js